var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"sidebar-star"},[_c('svg',{attrs:{"width":"16","height":"16","viewBox":"0 0 24 24","fill":_vm.color,"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 6.91-1.01z"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }